import { Injectable } from '@angular/core';
import { EstruturaPermissoesAcessoResult } from '../Results/EstruturaPermissoesAcessoResult';
import { SubMenuResult } from '../Results/SubMenuResult';
import { ETelaSistema } from '../Enums/ETelaSistema';
import { EMenuSistema } from '../Enums/EMenuSistema';
import { ETelaSistemaConfiguracao } from '../Enums/ETelaSistemaConfiguracao';

export const PERMISSOES_ACESSO_CARREGADAS_EVENT = 'ngx-permissoes-acesso-carregadas';

@Injectable({
  providedIn: 'root',
})
export class PermissoesAcessoServices {
  private errosLogados = new Set<string>();

  getPermissoesAcessoFromSession(): EstruturaPermissoesAcessoResult | null {
    const permissoesAcesso = sessionStorage.getItem('permissoesAcesso');
    if (permissoesAcesso) {
      try {
        return JSON.parse(permissoesAcesso) as EstruturaPermissoesAcessoResult;
      } catch (error) {
        console.error('Erro ao converter permissoesAcesso:', error);
      }
    }
    return null;
  }

  /** Grava na session e avisa componentes que dependem da permissão (carga assíncrona). */
  salvarPermissoesAcessoNaSessao(permissoes: EstruturaPermissoesAcessoResult): void {
    sessionStorage.setItem('permissoesAcesso', JSON.stringify(permissoes));
    window.dispatchEvent(new CustomEvent(PERMISSOES_ACESSO_CARREGADAS_EVENT));
  }

  /**
   * Retorna [consultar, cadastrar, editar, deletar].
   * Nunca lança: se menu/tela não existir ou session vazia, devolve tudo false.
   */
  getPermissoesAcessoTelaFromSession(menu: EMenuSistema, tela: ETelaSistema | ETelaSistemaConfiguracao): boolean[] {
    const semPermissao = [false, false, false, false];

    try {
      const permissoesAcesso = this.getPermissoesAcessoFromSession();
      if (!permissoesAcesso?.Menu?.length) {
        return semPermissao;
      }

      const menuDesc = String(menu ?? '').trim();
      const telaDesc = String(tela ?? '').trim();

      const menuSelecionado = permissoesAcesso.Menu.find(
        item => this.normalizarDescricao(item?.descricao) === this.normalizarDescricao(menuDesc),
      );
      if (!menuSelecionado?.SubMenu?.length) {
        return semPermissao;
      }

      const permissaoTela = menuSelecionado.SubMenu.find(
        item => this.normalizarDescricao(item?.descricao) === this.normalizarDescricao(telaDesc),
      );
      if (!permissaoTela) {
        return semPermissao;
      }

      return [
        this.toBool(permissaoTela.consultar),
        this.toBool(permissaoTela.cadastrar),
        this.toBool(permissaoTela.editar),
        this.toBool(permissaoTela.deletar),
      ];
    } catch (error) {
      const chave = `${menu}:${tela}`;
      if (!this.errosLogados.has(chave)) {
        this.errosLogados.add(chave);
        console.error('Erro ao obter permissões de acesso da tela:', error, { menu, tela });
      }
      return semPermissao;
    }
  }

  private normalizarDescricao(valor: string | null | undefined): string {
    return String(valor ?? '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLocaleLowerCase('pt-BR');
  }

  /** Mesma regra do menu lateral: API pode devolver consultar como bool, 0/1 ou string. */
  permiteConsultarSubMenu(sub: SubMenuResult | null | undefined): boolean {
    if (!sub) {
      return false;
    }
    return this.toBool(sub.consultar);
  }

  private toBool(valor: unknown): boolean {
    if (typeof valor === 'boolean') {
      return valor;
    }
    if (typeof valor === 'number') {
      return valor === 1;
    }
    if (typeof valor === 'string') {
      const v = valor.trim().toLowerCase();
      return v === 'true' || v === '1';
    }
    return false;
  }
}
